export var EventCreationState;
(function (EventCreationState) {
    EventCreationState[EventCreationState["None"] = 0] = "None";
    EventCreationState[EventCreationState["Creating"] = 1] = "Creating";
    EventCreationState[EventCreationState["Created"] = 2] = "Created";
    EventCreationState[EventCreationState["Failed"] = 3] = "Failed";
})(EventCreationState || (EventCreationState = {}));
